import classNames from "classnames";
import Link from "next/link";
import { Icon } from "../icon";
import { ISocialLinks } from "./social-links.types";

export const SocialLinks: ISocialLinks = ({ links, className }) => {
  return (
    <nav className={classNames("social-links flex flex-row gap-[40px] md:gap-[20px] lg:gap-[40px]", className)}>
      {links.map(({ slug, link }) => (
        <Link
          href={link}
          key={slug}
          target="_blank"
          rel="noreferrer"
        >
          <Icon
            name={slug}
            className="cursor-pointer hover:text-amber-300 min-w-[24px] duration-300"
          />
        </Link>
      ))}
    </nav>
  );
};
